import { Helmet } from "react-helmet-async";

/**
 * Composant SEO réutilisable pour chaque page.
 * Injecte title + meta description + canonical + Open Graph.
 */
export default function SEO({
  title,
  description,
  canonical,
  keywords,
  image = "https://eurochape.com/og-image.jpg",
}) {
  const fullTitle = title
    ? `${title} | Euro Chape — Chapiste Mulhouse & Alsace`
    : "Euro Chape — Chapiste à Mulhouse & Illzach | Chape, béton, isolation en Alsace";

  const desc =
    description ||
    "Euro Chape, artisan chapiste à Illzach près de Mulhouse. Chape traditionnelle, chape allégée, béton dur, isolation thermique et phonique, parquet, résine. Devis gratuit sous 48h.";

  const url = canonical || "https://eurochape.com/";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}
